var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "#686E7A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.8889V20.25H20.3889V18.8889H9.5ZM19.0278 8V13.4444C19.0278 14.5274 18.5976 15.566 17.8318 16.3318C17.066 17.0976 16.0274 17.5278 14.9444 17.5278C13.8615 17.5278 12.8229 17.0976 12.0571 16.3318C11.2913 15.566 10.8611 14.5274 10.8611 13.4444V8H12.9028V13.4444C12.9028 14.5701 13.8188 15.4861 14.9444 15.4861C16.0701 15.4861 16.9861 14.5701 16.9861 13.4444V8H19.0278Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.7635e39cde3a1ae54cffe78377dacd95.svg";
export { ForwardRef as ReactComponent };